// extracted by mini-css-extract-plugin
export default {"content":"styles_content__Sp5sc","title":"styles_title__cGlcS","active":"styles_active__GZq37","describtion":"styles_describtion__CKBwM"};